import styled from "styled-components";

export const ReferralTableListSection = styled.div`
  width: 100%;
  height: 80%;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
`;
